module.exports = __webpack_public_path__ + "media/app/components/MarketItem/NewDetails/kamereoLogo.bba97a88.svg";